import { useQuery } from '@tanstack/react-query';
import { WORK_LOCATIONS_KEY } from 'src/utils/constants/queryKeys';
import { getCorporateLocations } from '../services/fn-api/Company';

export const useGetCorporateLocations = (companyId: number) => {
  return useQuery({
    queryKey: [WORK_LOCATIONS_KEY, companyId],
    queryFn: () => getCorporateLocations(companyId),
    enabled: !!companyId,
  });
};
